import {
  createRouter,
  createWebHashHistory,
  createWebHistory,
  LocationQueryRaw,
} from 'vue-router';
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css';
import axios from 'axios';

import usePermission from '@/hooks/permission';
// import { useUserStore } from '@/store';
import { useUserStore } from '@/store';
import PageLayout from '@/layout/page-layout.vue';
import { isLogin } from '@/utils/auth';
import Login from './modules/login';
import Oauth from './modules/oauth';
import appRoutes from './modules';

const { VITE_OUTH2_URL } = import.meta.env;

NProgress.configure({ showSpinner: false }); // NProgress Configuration

const router = createRouter({
  // history: createWebHashHistory(''),
  history: createWebHistory(''),
  routes: [
    {
      path: '/',
      redirect: 'oauth',
    },
    Login,
    Oauth,
    {
      name: 'root',
      path: '/',
      component: PageLayout,
      children: appRoutes,
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'notFound',
      component: () => import('@/views/not-found/index.vue'),
    },
  ],
  scrollBehavior() {
    return { top: 0 };
  },
});

router.beforeEach(async (to, from, next) => {
  NProgress.start();
  const userStore = useUserStore();
  async function crossroads() {
    const Permission = usePermission();
    if (Permission.accessRouter(to)) await next();
    else {
      const destination = Permission.findFirstPermissionRoute(
        appRoutes,
        userStore.role
      ) || {
        name: 'notFound',
      };
      await next(destination);
    }
    NProgress.done();
  }
  if (isLogin()) {
    console.log(userStore.role);
    if (userStore.role) {
      crossroads();
    } else {
      if (to.name === 'login' || to.name === 'oauth') {
        next();
        NProgress.done();
        return;
      }
      try {
        await userStore.info();
        crossroads();
      } catch (error) {
        window.location.href = `${VITE_OUTH2_URL}&redirect_uri=${window.location.origin}%2Foauth`;
        // next({
        //   name: 'login',
        //   query: {
        //     redirect: to.name,
        //     ...to.query,
        //   } as LocationQueryRaw,
        // });
        // NProgress.done();
      }
    }
  } else {
    if (to.name === 'login' || to.name === 'oauth') {
      next();
      NProgress.done();
      return;
    }
    window.location.href = `${VITE_OUTH2_URL}&redirect_uri=${window.location.origin}%2Foauth`;

    // next({
    //   name: 'login',
    //   query: {
    //     redirect: to.name,
    //     ...to.query,
    //   } as LocationQueryRaw,
    // });
    // NProgress.done();
  }
});

// 页面访问日志记录
router.afterEach((to) => {
  try {
    axios.post('page-stats/log', { params: { page_url: to.fullPath } });
  } catch (e) { /* ignore */ }
});

export default router;
